import { useQuery } from '@apollo/client';
import { AppointmentEvent } from '@graphql/gql/graphql';
import { ME_APPT_AND_GUEST_CODE } from '@graphql/operations/user/meApptAndGuestCode';
import { useAttendeeHubConfig } from '@hooks/useAttendeeHubConfig';

export const useAppointmentPermissions = (): { canViewAppts: boolean; canManageAppts: boolean } => {
  const { isFeatureSettingEnabled } = useAttendeeHubConfig();
  const appointmentsFeatureEnabled = isFeatureSettingEnabled('APPOINTMENTS');

  const { data, loading, error } = useQuery(ME_APPT_AND_GUEST_CODE);
  const { apptEventCode, status, readOnly }: AppointmentEvent =
    data?.me?.event?.appointmentEvents?.[0] ?? ({} as AppointmentEvent);

  // users can view appointments if all of the following conditions are met:
  // - appointment event code must exist
  // - appointments feature in app builder is enabled
  const canViewAppts = !loading && !error && !!apptEventCode && appointmentsFeatureEnabled;

  // users can manage appointments if all of the following conditions are met:
  // - user can view appointments
  // - appointment event status must be active
  // - current user must not be a guest / appointment event website setting must not be read-only
  const isReadOnly = data?.me?.guest || readOnly;
  const canManageAppts = canViewAppts && status === 'ACTIVE' && !isReadOnly;

  return { canViewAppts, canManageAppts };
};
